import { render, staticRenderFns } from "./App.vue?vue&type=template&id=bb96b45c&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=bb96b45c&prod&lang=scss&"
import style1 from "./App.vue?vue&type=style&index=1&id=bb96b45c&prod&lang=scss&"
import style2 from "./App.vue?vue&type=style&index=2&id=bb96b45c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports